import React from 'react';
import styles from "./course-card-debug.module.css";
export const CourseCardDebug = props => {
  const {
    course
  } = props;
  const {
    input_features: inputFeatures,
    relevancy_score: relevancyScore,
    predictive_score: predictiveScore
  } = course;
  if (!inputFeatures) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: styles.debug
  }, /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("strong", null, 'Elasticsearch Score: '), relevancyScore), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("strong", null, 'Final Rank Score: '), predictiveScore), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("strong", null, 'Input Features to the Ranking Model: '))), /*#__PURE__*/React.createElement("ul", null, Object.keys(inputFeatures).sort().map(key => /*#__PURE__*/React.createElement("li", {
    key: key
  }, `${key}: `, /*#__PURE__*/React.createElement("i", null, JSON.stringify(inputFeatures[key], null, 4))))));
};
//# sourceMappingURL=course-card-debug.react-component.js.map